import React from 'react';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useDroppable } from '@dnd-kit/core';
import SectionBlock from './SectionBlock';

function DropZone({ id }) {
  const { isOver, setNodeRef } = useDroppable({ id });
  return (
    <div ref={setNodeRef} style={{
      height: isOver ? 40 : 8,
      transition: 'height 0.15s, background 0.15s',
      background: isOver ? 'rgba(59, 130, 246, 0.15)' : 'transparent',
      borderRadius: 6,
      border: isOver ? '2px dashed var(--primary)' : '2px dashed transparent',
      margin: '2px 0',
    }} />
  );
}

export default function SectionList({ sections, onUpdateSection, onRemoveSection, dispatch, onSaveSection, collapseSignal }) {
  return (
    <SortableContext items={sections.map(s => s.id)} strategy={verticalListSortingStrategy}>
      <div style={{ minHeight: 200 }}>
        {sections.length === 0 ? (
          <EmptyDropZone />
        ) : (
          <>
            {sections.map(section => (
              <SectionBlock
                key={section.id}
                section={section}
                onUpdate={updates => onUpdateSection(section.id, updates)}
                onRemove={() => onRemoveSection(section.id)}
                dispatch={dispatch}
                onSaveSection={onSaveSection}
                collapseSignal={collapseSignal}
              />
            ))}
          </>
        )}
      </div>
    </SortableContext>
  );
}

function EmptyDropZone() {
  const { isOver, setNodeRef } = useDroppable({ id: 'empty-canvas' });
  return (
    <div ref={setNodeRef} style={{
      padding: 40, textAlign: 'center',
      border: isOver ? '2px dashed var(--primary)' : '2px dashed var(--border)',
      background: isOver ? 'rgba(59, 130, 246, 0.08)' : 'transparent',
      borderRadius: 'var(--radius-lg)', color: 'var(--text-secondary)',
      transition: 'all 0.2s',
    }}>
      <div style={{ fontSize: 32, marginBottom: 8 }}>📄</div>
      <div style={{ fontSize: 14, fontWeight: 500 }}>No sections yet</div>
      <div style={{ fontSize: 12, marginTop: 4 }}>Click or drag sections from the palette to add them.</div>
    </div>
  );
}
